import { createSelector } from 'reselect';
import getQuantities from 'selectors/exchange/getQuantities';

const getActiveStore = ({ exchange }) => exchange.activeStore;
const getFilterString = (state, props) => props.filterString;
const getShops = ({ exchange }) => exchange.shops;

const inputFuncs = [getActiveStore, getFilterString, getQuantities, getShops];

const outputFunc = (activeStore, filterString, quantities, shops) => {
  const isNonZeroIfSelling = makeIsNonZeroIfSelling({ activeStore, quantities });
  // If we have a filterString then we want to filter out non-matches
  const matchesFilterString = makeNameMatchesFilterString({ filterString });

  // Ensure we have an array
  const items = (shops[activeStore] || { items: [] }).items || [];

  // Apply the filters
  return items
    .filter(isNonZeroIfSelling)
    .filter(matchesFilterString);
};

export function makeIsNonZeroIfSelling({ activeStore, quantities }) {
  // If activeStore is null, then we want to filter out items whose quantities are at 0
  return (item) => {
    const qualityId = item.availability.quality.id;
    return activeStore !== null || quantities[qualityId] > 0;
  };
}

export function makeNameMatchesFilterString({ filterString }) {
  return (item) => {
    const qualityName = item.availability.quality.name;
    return qualityName.toLowerCase().indexOf(filterString.toLowerCase()) >= 0;
  };
}

export default createSelector(inputFuncs, outputFunc);